import { REDUX_ACTIONS, GAME_ID } from '../../data/constants';
import { persistStateTypes } from '../../../reducers/persistStateReducer';

const initState = {
  isOnboarded: false,
  highestLevelEarned: 0,
  questData: [],
};

const sessionReducer = (state = initState, { type, stateData, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // set isOnboarded after onboarding completion
    case REDUX_ACTIONS.COMPLETE_ONBOARDING:
      return {
        ...state,
        isOnboarded: true,
      };

    case REDUX_ACTIONS.UPDATE_HIGHEST_LEVEL_EARNED:
      return {
        ...state,
        highestLevelEarned: payload,
      };

    case REDUX_ACTIONS.SAVE_PROGRESS_DATA:
      return {
        ...state,
        questData: payload,
      };

    case REDUX_ACTIONS.REMOVE_PROGRESS_DATA:
      return {
        ...state,
        questData: payload,
      };

    case persistStateTypes.REQUESTRESPONSE_GAMESTATE: {
      const gameData = stateData[GAME_ID]?.GameData?.session ?? {};
      return {
        ...state,
        ...gameData,
      };
    }

    default:
      return state;
  }
};

export default sessionReducer;
